import { render, staticRenderFns } from "./FeatureInfo.vue?vue&type=template&id=18853381&scoped=true&lang=pug&"
import script from "./FeatureInfo.vue?vue&type=script&lang=js&"
export * from "./FeatureInfo.vue?vue&type=script&lang=js&"
import style0 from "./FeatureInfo.vue?vue&type=style&index=0&id=18853381&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18853381",
  null
  
)

component.options.__file = "FeatureInfo.vue"
export default component.exports